import { render } from "./QuestionTypeList.vue?vue&type=template&id=7d2f2b38"
import script from "./QuestionTypeList.vue?vue&type=script&lang=js"
export * from "./QuestionTypeList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__